import { render } from "./Security_User_Dialog.vue?vue&type=template&id=4f72bec6&scoped=true&ts=true"
import script from "./Security_User_Dialog.vue?vue&type=script&lang=ts"
export * from "./Security_User_Dialog.vue?vue&type=script&lang=ts"

import "./Security_User_Dialog.vue?vue&type=style&index=0&id=4f72bec6&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f72bec6"]])

export default __exports__